import { Estimate } from '@/types/coral-types';
import money from './money';

export function sanitizeEstimate(estimate: Estimate) {
  if (
    typeof estimate['ATH PAD'] !== 'undefined' &&
    estimate['ATH PAD']?.total > 0
  ) {
    estimate.caucao = estimate['ATH PAD'].total;
    estimate.total = (estimate.total as number) - estimate.caucao;
  } else {
    estimate.caucao = 0;
  }

  estimate.total_without_interests =
    estimate?.ADMIN?.total > 0
      ? estimate.total - estimate.ADMIN.total
      : estimate.total;

  return estimate;
}

export function getOptionalEstimate(estimate: Estimate, code: string) {
  let opEstimate = {
    code: '',
    quantity: 0,
    total: 0,
  };

  Object.entries(estimate).map(key => {
    if (estimate[key[0]]?.code === code) {
      estimate[key[0]];
      opEstimate = estimate[key[0]];
    }
  });

  return opEstimate;
}

export function showDailyValue(value: number, days: number) {
  return `${days}x de ${money(value / days)} = ${money(value)}`;
}

export function showDailyValueResume(value: number, days: number) {
  return `${days}x de ${money(value / days)}`;
}